import {OPEN_SIDEBAR, CLOSE_SIDEBAR} from '../actions/sidebarAction'

const initial_state = {
    sidebarState: false
}



const sidebarReducer = (state = initial_state, action) => {
    switch (action.type) {
        case OPEN_SIDEBAR: {
            return {
                sidebarState: true
            }
        }
        case CLOSE_SIDEBAR: {
            return {
                sidebarState: false
            }
        }
        default: return state;
    }
}

export default sidebarReducer